import React, { useState, useEffect } from 'react';
import { FiPlus, FiFileText } from 'react-icons/fi';
import AddRFIModal from '../components/AddRFIModal';
import RFIDetailModal from '../components/RFIDetailModal';
import './RFIs.css';

const RFIs = ({ token }) => {
  const [rfis, setRfis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedRFI, setSelectedRFI] = useState(null);

  useEffect(() => {
    fetchRFIs();
  }, []);

  const fetchRFIs = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/rfis`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setRfis(data.rfis || []);
      }
    } catch (error) {
      console.error('Failed to fetch RFIs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddRFI = () => {
    fetchRFIs();
  };

  const handleUpdateRFI = () => {
    fetchRFIs();
    setSelectedRFI(null);
  };

  const getStatusColor = (status) => {
    const colors = {
      'Open': '#F4A340',
      'In Review': '#0F0F10',
      'Closed': '#1DBF73'
    };
    return colors[status] || '#F4A340';
  };

  if (loading) return <div className="loading-spinner"></div>;

  return (
    <div className="rfis-page">
      <div className="rfis-header">
        <h1 className="rfis-title">RFIs</h1>
        <button 
          className="btn btn-primary" 
          onClick={() => setShowAddModal(true)}
          data-testid="create-rfi-button"
        >
          <FiPlus size={18} />
          <span>New RFI</span>
        </button>
      </div>
      
      <AddRFIModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onAdd={handleAddRFI}
        token={token}
      />
      
      <RFIDetailModal
        isOpen={!!selectedRFI}
        onClose={() => setSelectedRFI(null)}
        rfi={selectedRFI}
        token={token}
        onUpdate={handleUpdateRFI}
      />
      
      <div className="rfis-grid">
        {rfis.map((rfi) => (
          <div 
            key={rfi.id} 
            className="rfi-card" 
            onClick={() => setSelectedRFI(rfi)}
            data-testid="rfi-card"
            style={{ borderLeft: `4px solid ${getStatusColor(rfi.status)}` }}
          >
            <div className="rfi-card-header">
              <div 
                className="rfi-card-icon"
                style={{ 
                  backgroundColor: `${getStatusColor(rfi.status)}20`,
                  color: getStatusColor(rfi.status)
                }}
              >
                <FiFileText size={20} />
              </div>
              <span 
                className="status-pill"
                style={{ 
                  backgroundColor: getStatusColor(rfi.status),
                  color: '#ffffff'
                }}
              >
                {rfi.status}
              </span>
            </div>
            <div className="rfi-card-id">{rfi.rfiId}</div>
            <div className="rfi-card-subject">{rfi.subject}</div>
            <div className="rfi-card-desc">{rfi.description}</div>
            {rfi.dueDate && (
              <div className="rfi-card-due">Due: {new Date(rfi.dueDate).toLocaleDateString()}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RFIs;